<script>
import * as icons from 'vue-feather-icons'

export default {
  name: 'FeatherIcon',
  functional: true,
  props: {
    icon: {
      required: true,
      type: [String, Object],
    },
    size: {
      type: String,
      default: '14',
    },
    badge: {
      type: [String, Object, Number],
      default: null,
    },
    badgeClasses: {
      type: [String, Object, Array],
      default: 'badge-primary',
    },
    title: {
      type: String,
      default: '',
    },
  },
  render(h, { props, data }) {
    const svg = h(icons[props.icon], { props: { size: props.size }, ...data })

    if (!props.badge) {
      return h('span', {
        staticClass: 'feather-icon position-relative',
        attrs: { title: props.title },
      }, [svg])
    }

    const badgeEl = h('span', { staticClass: 'badge badge-up badge-pill', class: props.badgeClasses }, [props.badge])

    return h('span', {
      staticClass: 'feather-icon position-relative',
      attrs: { title: props.title },
    }, [svg, badgeEl])
  },
}
</script>

<style lang="scss">
svg.feather {
  outline: none
}
</style>
